module.exports = __webpack_public_path__ + "img/avatar1.fc9fa6d9.svg";